<template>
  <div>
    <v-card id="referral-form" class="pa-2">
      <v-layout justify-end>
        <v-btn flat icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-layout>

      <template v-if="rawData">
        <template v-if="currentPage === 1">
          <Page1 :data="localData.page_1" @onSaveForm="handleSaveForm" />
        </template>
        <template v-if="currentPage === 2">
          <Page2
            :data="localData.page_2"
            @onBackPage="
              currentPage--
              goToTop()
            "
            @onSubmitForm="handleSubmitForm"
          />
        </template>
      </template>
    </v-card>
  </div>
</template>

<script>
import Page1 from './Form/Page1.vue'
import Page2 from './Form/Page2.vue'
export default {
  components: {
    Page1,
    Page2
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      rawData: null,
      currentPage: 1,
      localData: {
        page_1: {
          id: '',
          drinker_name: '',
          is_fill_date: '',
          drinker_gender: '',
          drinker_year: '',
          score: '',
          risk: '',
          motivation_behavior_change: '',
          is_stop_drink_in_one_year: null,
          low_risk_group: null,
          high_risk_group: null,
          filler_name: '',
          filler_relation: '',
          assessor_name: ''
        },
        page_2: {
          physical_symptoms: null,
          physical_symptoms_detail: '',
          risk_self_harm: null,
          risk_self_harm_detail: '',
          addict_alcohol: null,
          addict_alcohol_detail: '',
          addict_stimulants: null,
          addict_stimulants_detail: '',
          addict_marijuana_kratom: null,
          addict_marijuana_kratom_detail: '',
          addict_etc: null,
          addict_etc_detail: '',
          stress: null,
          stress_detail: '',
          depressed_mood: null,
          depressed_mood_detail: '',
          sleeping_problem: null,
          sleeping_problem_detail: '',
          weight_change: null,
          weight_change_detail: '',
          risk_assist_level: '',
          risk_assist_deatil: '',
          motivation_behavior_change_level: '',
          motivation_behavior_change_detail: '',
          risk_severe_withdrawal_symptoms_level: '',
          risk_severe_withdrawal_symptoms_detail: ''
        }
      }
    }
  },
  watch: {
    value: {
      handler() {
        this.handleInit()
      },
      deep: true
    },
    rawData: {
      handler() {
        this.handleTransformData()
      },
      deep: true
    }
  },
  mounted() {
    this.handleInit()
  },
  methods: {
    handleInit() {
      this.rawData = this.data
    },
    handleTransformData() {
      if (this.rawData) {
        const {
          id,
          drinker_name,
          is_fill_date,
          drinker_gender,
          drinker_year,
          score,
          risk,
          motivation_behavior_change,
          is_stop_drink_in_one_year,
          low_risk_group,
          high_risk_group,
          filler_name,
          filler_relation,
          assessor_name,
          ...rest
        } = this.rawData

        this.localData.page_1 = {
          id,
          drinker_name,
          is_fill_date,
          drinker_gender,
          drinker_year,
          score,
          risk,
          motivation_behavior_change,
          is_stop_drink_in_one_year,
          low_risk_group,
          high_risk_group,
          filler_name,
          filler_relation,
          assessor_name
        }

        this.localData.page_2 = { ...rest }
      }
    },
    handleSaveForm(data) {
      this.localData.page_1 = {
        ...data
      }
      this.currentPage++
      this.goToTop()
    },
    goToTop() {
      document.getElementById('referral-form').scrollIntoView({ behavior: 'smooth' })
    },
    handleSubmitForm(data) {
      try {
        const tempData = {
          ...this.localData.page_1,
          ...data
        }

        const payload = {}

        Object.keys(tempData).forEach((key) => {
          if (!['register_date', 'risk_new', 'drinker_age'].includes(key)) {
            Object.assign(payload, { [key]: tempData[key] })
          }
        })

        this.$emit('onSaveForm', payload)
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/SelfReferral/SelfReferralFormDialog.vue